
import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//货位列表
export async function getList(params) {
    return post(erpserver+'/storekw/getList', params, true)
}

//货位详情
export async function getDetails(params) {
    return post(erpserver+'/storekw/getDetails', params, true)
}

//仓库下拉
export async function selectWarehouse(params) {
    return post(erpserver+'/storekq/selectWarehouse', params, true)
}

//品种列表（子）
export async function getPzList(params) {
    return post(erpserver+'/storekw/getPzList', params, true)
}

//品种详情（子）
export async function getPzDetails(params) {
    return post(erpserver+'/storekw/getPzDetails', params, true)
}

//库区下拉
export async function selectStorekq(params) {
    return post(erpserver+'/storekw/selectStorekq', params, true)
}

//品种下拉
export async function selectPz(params) {
    return post(erpserver+'/storekw/selectPz', params, true)
}

//单元下拉
export async function selectPztype(params) {
    return post(erpserver+'/storekw/selectPztype', params, true)
}

// //品种类型下拉
// export async function selectPztype(params) {
//     return post(erpserver+'/storekw/selectPztype', params, true)
// }

//货位保存
export async function save(params) {
    return post(erpserver+'/storekw/save', params, true)
}

//货位删除验证
export async function beforeRemove(params) {
    return post(erpserver+'/storekw/beforeDelete', params, true)
}

//货位删除
export async function remove(params) {
    return post(erpserver+'/storekw/delete', params, true)
}

//品种保存
export async function savePm(params) {
    return post(erpserver+'/storekw/savePm', params, true)
}

//品种删除
export async function removePm(params) {
    return post(erpserver+'/storekw/deletePm', params, true)
}